import { HillDetailView } from '@/components/hill-detail-view';
import { sessionQueryOptions } from '@/lib/session-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/archive/:hillId` - same component as `/hills/:hillId`, mounted under
 * `/archive` so the back link points back to the archive list rather than
 * the home.
 *
 * We do not enforce that the hill is actually Done at the route level: the
 * URL is a navigation hint, not a state assertion. If a user lands here
 * with a live hill the page renders correctly (the read-only switch comes
 * from `hill.completedAt`, not from the route), they just get a less
 * useful "Back to archive" link. Manual URL edits are an edge case we
 * accept rather than a happy path we redirect.
 */
export const Route = createFileRoute('/archive/$hillId')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    if (!session) {
      throw redirect({ to: '/login' });
    }
  },
  component: HillDetailArchivePage,
});

function HillDetailArchivePage() {
  const { hillId } = Route.useParams();
  return <HillDetailView hillId={hillId} mode="archive" />;
}
